exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidenav-container {\n  background-color: initial;\n}\n\nmd-card {\n  margin: 0.1em auto;\n}\n\nmd-card-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.mat-select {\n  margin: 1.5em 0;\n}\n\n.button-container {\n  margin: 0 auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9104/wa9104.component.css
// module id = ../../../../../src/app/pages/wa9Master/wa9104/wa9104.component.css
// module chunks = main